import { render, staticRenderFns } from "./iam-importer-page.vue?vue&type=template&id=81317498&"
import script from "./iam-importer-page.vue?vue&type=script&lang=js&"
export * from "./iam-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports